 
import React, { type FC, type ReactNode } from "react";

import CloseButton from "@/components/flowbite/button/close-button";
import { cn } from "@/shared/helpers/cn.helper";

interface IProps {
  message?: string | ReactNode;
  description?: string | ReactNode;
  type: "success" | "warning" | "error";
  onClose?: () => void;
}

const Toast: FC<IProps> = ({
  message,
  description,
  type,
  onClose,
}) => {
  const iconSvg = {
    success: (
      <svg
        fill="none"
        height="20"
        viewBox="0 0 20 20"
        width="20"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10 0C15.5228 0 20 4.47715 20 10C20 15.5228 15.5228 20 10 20C4.47715 20 0 15.5228 0 10C0 4.47715 4.47715 0 10 0ZM15.5303 5.96973C15.2374 5.67717 14.7625 5.677 14.4697 5.96973L8 12.4395L5.53027 9.96973C5.23738 9.67683 4.76262 9.67683 4.46973 9.96973C4.17683 10.2626 4.17683 10.7374 4.46973 11.0303L7.46973 14.0303C7.76265 14.3228 8.23749 14.3231 8.53027 14.0303L15.5303 7.03027C15.823 6.73748 15.8228 6.26263 15.5303 5.96973Z"
          fill="#1E8E3E"
        />
      </svg>
    ),
    warning: (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M10.2664 4.01538C11.0354 2.67803 12.9652 2.67799 13.7342 4.01538L21.7771 18.0027C22.5438 19.336 21.5808 20.9998 20.0428 20.9998H3.95682C2.41892 20.9996 1.45679 19.3359 2.22342 18.0027L10.2664 4.01538ZM12.5115 16.4412C12.2036 16.1643 11.729 16.1891 11.4519 16.4968L11.4422 16.5076C11.1652 16.8153 11.1903 17.29 11.4978 17.5671C11.8057 17.8442 12.2803 17.8194 12.5574 17.5115L12.5672 17.5007C12.8442 17.1928 12.8194 16.7182 12.5115 16.4412ZM11.9998 8.24976C11.5858 8.24987 11.2499 8.58573 11.2498 8.99976V12.9998C11.2498 13.4139 11.5857 13.7496 11.9998 13.7498C12.414 13.7498 12.7498 13.414 12.7498 12.9998V8.99976C12.7496 8.58566 12.4139 8.24976 11.9998 8.24976Z"
          fill="#DD8F04"
        />
      </svg>
    ),
    error: (
      <svg
        fill="none"
        height="24"
        viewBox="0 0 24 24"
        width="24"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M12 2C17.5228 2 22 6.47715 22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2ZM12.5117 16.4414C12.2038 16.1643 11.7292 16.1892 11.4521 16.4971L11.4424 16.5078C11.1653 16.8156 11.1903 17.2903 11.498 17.5674C11.8059 17.8445 12.2805 17.8196 12.5576 17.5117L12.5674 17.501C12.8445 17.1931 12.8196 16.7185 12.5117 16.4414ZM12 6.25C11.5858 6.25 11.25 6.58579 11.25 7V13C11.25 13.4142 11.5858 13.75 12 13.75C12.4142 13.75 12.75 13.4142 12.75 13V7C12.75 6.58579 12.4142 6.25 12 6.25Z"
          fill="#D93025"
        />
      </svg>
    ),
  };

  return (
    <div
      className="flex w-full flex-row gap-4 overflow-hidden rounded-lg bg-white p-4 shadow-xl"
      role="alert"
    >
      <div className="flex w-full flex-row gap-3">
        <div className={cn("flex justify-center", {
          "items-start": !!description,
          "items-center": !description,
        })}
        >{iconSvg[type]}</div>
        <div className="flex flex-1 flex-col justify-center gap-1">
          {message && (
            <h3 className="text-sm font-medium text-text-500">{message}</h3>
          )}
          {description && description !== "" && <p className="text-light-300 text-sm font-normal">{description}</p>}
        </div>
      </div>
      <div className="flex items-center">
        <CloseButton onClose={onClose} />
      </div>
    </div>
  );
};

export default Toast;
